import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  ButtonIcon,
  ButtonText,
} from '../../../core/controls/button/Button';
import submitOrder from '../../api/submitOrder';
import { getDeepUrl, getBaseUrl } from '../../common/urlBuilder';
import { updatePreOrderStatus } from '../../store/actions';
import { Translate } from 'core/translate';
import ProcessingModal from './processingModal/ProcessingModal';
import { useModelInfo } from '../../common/ModelInfoContext';
import Checkbox from '../../../core/controls/checkbox/Checkbox';
import { translate } from '../../utils/translate/translations';
import { SvgIcon } from '../../../core/icons';
import { SimpleOptionDetailsAlt } from '../../common/optionDetails/simpleOptionDetails/SimpleOptionDetails';

const SubmitOrder = ({
  config,
  params,
  modelInfo,
  onSaveClick,
  currentBuildSavedKey,
  reservation,
  dispatch,
  appResources,
  summaryStep,
}) => {
  const { styleId, ss } = config;
  const { v3ServicesPath } = modelInfo;
  const {
    id: reservationId,
    dealer,
    chargingUnit: defaultChargingUnit,
    exclusiveCustomer,
    alternateDriveType,
  } = reservation;
  const { state: bacRegionCode } = dealer?.address;
  const { lccKey } = useModelInfo();
  const { chargingUnit } = appResources;
  const navigate = useNavigate();

  const [isProcessingSubmit, setIsProcessingSubmit] = useState(false);
  const [isChargingUnitSelected, setIsChargingUnitSelected] = useState(
    defaultChargingUnit
  );
  const [showChargerModal, setShowChargerModal] = useState(false);

  const onSubmit = () => {
    const { postalCode } = params;
    const configUrl = `${getDeepUrl(
      getBaseUrl(),
      config,
      postalCode
    )}&${lccKey}=${reservationId}`;
    setIsProcessingSubmit(true);
    submitOrder(
      v3ServicesPath,
      params,
      styleId,
      ss,
      configUrl,
      reservationId,
      isChargingUnitSelected,
      bacRegionCode,
      exclusiveCustomer,
      alternateDriveType
    ).then((success) => {
      dispatch(updatePreOrderStatus(success));
      navigate(success ? '../confirmation' : '../error');
      setIsProcessingSubmit(false);
    });
  };

  const onChargingUnitChange = () => {
    setIsChargingUnitSelected(!isChargingUnitSelected);
  };

  const heartIconName = currentBuildSavedKey ? 'save-active' : 'save-default';
  const analyticsKey = `next steps`;
  const header = summaryStep?.tidHeader.replace('${dealer}', dealer.title);
  const displayChargeUnitCheckbox = chargingUnit.displayCheckbox;

  return (
    <div className="ev-next-steps">
      <ProcessingModal isOpen={isProcessingSubmit} />
      <span className="ev-next-steps__header">{header}</span>
      <div className="ev-next-steps__disclaimer">
        {summaryStep?.tidSubHeader}
      </div>
      {chargingUnit && (
        <>
          <div className="charging-unit-option__container">
            <div className="charging-unit-option__inner-container">
              <div className="charging-unit-option__header-container">
                <div className="charging-unit-option__header">
                  {chargingUnit.header}
                </div>
                <button
                  onClick={() => {
                    setShowChargerModal(true);
                  }}>
                  <SvgIcon
                    name="info"
                    className="charging-unit__info-icon stat-image-link"
                    data-dtm={analyticsKey}
                  />
                </button>
              </div>
              <Checkbox
                analyticsKey={analyticsKey}
                checked={isChargingUnitSelected}
                onChange={onChargingUnitChange}
                customModifier="feature-filter"
                className="charging-unit__checkbox"
                displayCheckbox={displayChargeUnitCheckbox}
                customCheckName="check-mark">
                <span
                  className={`charging-unit-option__label ${
                    displayChargeUnitCheckbox ? '' : 'no-click'
                  } `}
                  dangerouslySetInnerHTML={{
                    __html: chargingUnit.subHeader,
                  }}
                />
              </Checkbox>
            </div>
          </div>
          {showChargerModal && (
            <SimpleOptionDetailsAlt
              onClose={() => {
                setShowChargerModal(false);
              }}
              onSelect={() => {
                setIsChargingUnitSelected(true);
                setShowChargerModal(false);
              }}
              onDeselect={() => {
                setIsChargingUnitSelected(false);
                setShowChargerModal(false);
              }}
              option={{
                longCfd: chargingUnit.longDescription,
                description: chargingUnit.title,
                largeImageUrl: chargingUnit.imageUrl,
                primaryButtonLabel: translate(
                  'stp.ev.charging.unit.selection.btn.label'
                ),
                secondaryButtonLabel: translate(
                  'stp.ev.charging.unit.cancel.btn.label'
                ),
              }}
              showControls={displayChargeUnitCheckbox}
            />
          )}
        </>
      )}
      <Button
        className="ev-next-steps__submit-order-btn stat-button-link"
        onClick={onSubmit}
        data-dtm={analyticsKey}>
        <ButtonText>
          <Translate value="byo.cta.label.sor" />
        </ButtonText>
        <ButtonIcon className="button__icon--right" name="submit" />
      </Button>
      <span className="ev-next-steps__save-message">
        <Translate value="ev.next.steps.save.builds.header.v3" />
      </span>
      <Button
        className="ev-next-steps__save-btn stat-text-link"
        onClick={onSaveClick}
        data-dtm={analyticsKey}>
        <ButtonIcon className="button__icon--left" name={heartIconName} />
        <ButtonText>
          {currentBuildSavedKey ? (
            <Translate value="ev.next.steps.saved.builds.btn.label.v3" />
          ) : (
            <Translate value="ev.next.steps.save.builds.btn.label.v3" />
          )}
        </ButtonText>
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { config, params, reservation, appResources } = state;

  return {
    config,
    params,
    reservation,
    appResources,
  };
};

export default connect(mapStateToProps)(SubmitOrder);
